import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'inline-flex',
      cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
      pointerEvents: ({ disabled }) => (disabled ? 'none' : 'all'),
    },
    logoAnyword: {
      height: 24,
      width: 'auto',
      color: COLORS.primary.default,
    },
    logoTeads: {
      fontSize: theme.typography.pxToRem(72),
      color: '#000',
    },
    light: {
      color: theme.palette.common.white,
    },
  }),
  { name: 'AppLogo' }
);
